const ADDING_HOUSEHOLD_MEMBER = 'ADDING_HOUSEHOLD_MEMBER';
const ADDING_HOUSEHOLD_MEMBER_FROM_HOUSEHOLD_SECTION = 'ADDING_HOUSEHOLD_MEMBER_FROM_HOUSEHOLD_SECTION';
const EDITING_HOUSEHOLD_MEMBER = 'EDITING_HOUSEHOLD_MEMBER';
const EDITING_INCOMES_AND_DEDUCTIONS = 'EDITING_INCOMES_AND_DEDUCTIONS';
const EDITING_HOUSEHOLD_MEMBER_ADDRESS = 'EDITING_HOUSEHOLD_MEMBER_ADDRESS';
const EDITING_PRIMARY_HOUSEHOLD_CONTACT = 'EDITING_PRIMARY_HOUSEHOLD_CONTACT';
const EDITING_ADDITIONAL_INFORMATION = 'EDITING_ADDITIONAL_INFORMATION';
const FIXING_TAX_RELATIONSHIP = 'FIXING_TAX_RELATIONSHIP';
const MANAGE_SPOUSE = 'MANAGE_SPOUSE';
const REVIEW_AFTER_SIGN = 'REVIEW_AFTER_SIGN';
const REVIEW_BEFORE_SUBMIT = 'REVIEW_BEFORE_SUBMIT';
const REVIEW_BEFORE_SUBMIT_FAMILY_AND_HOUSEHOLD = 'REVIEW_BEFORE_SUBMIT_FAMILY_AND_HOUSEHOLD';
const REVIEW_HOUSEHOLD_SECTION = 'REVIEW_HOUSEHOLD_SECTION';
const REVIEW_INCOME_SECTION = 'REVIEW_INCOME_SECTION';

export const EXCEPTIONS = {
    ADDING_HOUSEHOLD_MEMBER,
    ADDING_HOUSEHOLD_MEMBER_FROM_HOUSEHOLD_SECTION,
    EDITING_HOUSEHOLD_MEMBER,
    EDITING_INCOMES_AND_DEDUCTIONS,
    EDITING_HOUSEHOLD_MEMBER_ADDRESS,
    EDITING_PRIMARY_HOUSEHOLD_CONTACT,
    EDITING_ADDITIONAL_INFORMATION,
    FIXING_TAX_RELATIONSHIP,
    MANAGE_SPOUSE,
    REVIEW_AFTER_SIGN,
    REVIEW_BEFORE_SUBMIT,
    REVIEW_BEFORE_SUBMIT_FAMILY_AND_HOUSEHOLD,
    REVIEW_HOUSEHOLD_SECTION,
    REVIEW_INCOME_SECTION
};